import BigNumber from 'bignumber.js'
import { DEFAULT_TOKEN_DECIMAL } from 'config'

const getBoostFactor = (
  userFarmPosition: BigNumber,
  baseAllocation: BigNumber,
  boostAllocation: BigNumber,
  farmTotalSize: BigNumber,
  adjustShares: BigNumber,
): number => {
  if (userFarmPosition.isZero() || adjustShares.isZero() || farmTotalSize.isZero() || baseAllocation.isZero()) return 1

  // (boostAllocation / baseAllocation) *
  // (adjustShare * totalFarmSize / userFarmPosition)
  const allocationMultiplier = boostAllocation.div(baseAllocation)
  const adjustSharesPosition = adjustShares
    .div(DEFAULT_TOKEN_DECIMAL)
    .times(new BigNumber(farmTotalSize.toString()))
    .div(new BigNumber(userFarmPosition.toString()))

  return parseFloat(
    (1 + allocationMultiplier.times(new BigNumber(adjustSharesPosition.toString())).toNumber()).toFixed(3),
  )
}

export default getBoostFactor
